import { Link } from "react-router-dom";
import type { GameId } from "@hunch/core";
import { GameIcon } from "./illustrations/GameIcon.js";
import styles from "./GameTile.module.css";

interface GameTileProps {
  gameId: GameId;
  route: string;
  name: string;
  tagline: string;
  info: string;
}

export function GameTile({ gameId, route, name, tagline, info }: GameTileProps) {
  return (
    <Link to={route} className={styles.tile}>
      <GameIcon gameId={gameId} className={styles.icon} />
      <h2 className={styles.name}>{name}</h2>
      <p className={styles.tagline}>{tagline}</p>
      <p className={styles.info}>{info}</p>
    </Link>
  );
}
